// Step labels — translated lookup.
//
// Single source of truth for the human-readable name of each
// workflow step. Lifted to i18n in v0.5.0i+2 so the 6 stepper
// buttons + every "Open Step N · {label} →" deep-link translate
// when the operator switches locale.
//
// Callers receive `t` via the `react-i18next` `useTranslation()`
// hook, and pass it in. The functional shape (rather than a
// const map) keeps the rule "no hooks outside components"
// satisfied — this module is pure JS.
import { useTranslation } from "react-i18next";

/** Returns the translated label for a 1-indexed step number. */
export const stepLabelFor = (stepIdx, t) => {
  const key = `ui.stepper.step${stepIdx}`;
  const translated = t(key);
  // i18next returns the key verbatim if the translation is missing
  // — fall back to a numeric placeholder in that case.
  if (translated === key) {
    return t("ui.stepper.step_fallback", { idx: stepIdx });
  }
  return translated;
};

/** React hook variant — most callers want this. */
export const useStepLabel = () => {
  const { t } = useTranslation();
  return (stepIdx) => stepLabelFor(stepIdx, t);
};

export default stepLabelFor;
